define(["angular", "./toastModule", "text!./nlgToast.html"], function (angular, module, template) {
    "use strict";

    return module.directive("nlgToast", [function () {
        return {
            restrict: "E",
            template: template,
            scope: {
                localVersion: "@"
            },
            controller: ["$scope", "versionService", function ($scope, versionService) {
                $scope.contract = null;
                $scope.closed = true;

                $scope.$watch("localVersion", function (newVal) {
                    if (newVal && versionService.shouldShow()) {
                        versionService.getRemoteVersionInfo().then(function (remote) {

                            var bucketData = angular.isArray(remote) ? remote[1] : remote;
                            if (versionService.isNewer(newVal, bucketData.latest.version)) {
                                $scope.contract = bucketData.latest;
                                $scope.closed = false;
                            }
                        });
                    }
                });

                $scope.close = function () {
                    $scope.closed = true;
                    if ($scope.contract && $scope.contract.version) {
                        versionService.markAsVisited($scope.contract.version);
                    }
                };

                $scope.isClosed = function () {
                    return $scope.closed;
                };
            }]
        };
    }]);
});